import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ApplicationSkeleton from '~/components/ApplicationSkeleton';

const AsyncTermsOfUse = lazy(() => import('~/containers/TermsOfUse'));

export default [
  <Route path="/terms">
    <Suspense fallback={<ApplicationSkeleton />}>
      <AsyncTermsOfUse />
    </Suspense>
  </Route>,
];
